// extracted by mini-css-extract-plugin
export default {"accordion_item":"styles_accordion_item__p0+Bt","apexcharts-yaxis-label":"styles_apexcharts-yaxis-label__fi08n","custom-yaxis-label":"styles_custom-yaxis-label__z8nVG"};